import React from "react";
import { useAppTranslation } from "../../../../../../../i18n/useAppTranslation";
import { DateRangePicker } from "../../../../../../../shared/DateRangePicker/DateRangePicker";
import { ReportHeader } from "../../../../../components/ReportHeader/ReportHeader";
import { useCurrentUserQuery } from "../../../../../../../api/queries/useUserQuery";
import { Button } from "../../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { svg } from "../../../../../../../assets/svg";
import { InputSearch } from "../../../../../../../boxes/InputSearch/InputSearch";

export function Header({ period, search, isReportsLoading, downloadExcel }) {
  var { tBi: t } = useAppTranslation.BusinessInsights();
  var { data: user } = useCurrentUserQuery();

  return (
    <ReportHeader label={t("shopifyProductSalesReport.label")}>
      <InputSearch value={search.value} onChange={search.update} />
      <DateRangePicker
        isDisabled={isReportsLoading}
        size="small"
        dateFormat={user?.dateFormat}
        onChange={({ startDate, endDate }) => {
          period.update({
            from: startDate,
            to: endDate,
          });
        }}
        value={{
          startDate: period.value.from,
          endDate: period.value.to,
        }}
      />
      <Button
        size="small"
        variant="outlined"
        onClick={downloadExcel.initiate}
        isDisabled={downloadExcel.isLoading || isReportsLoading}
        leftAdornment={
          downloadExcel.isLoading ? (
            <CircularProgress size="small" />
          ) : (
            <img src={svg.downloadPrimary} alt="dl" width="20px" />
          )
        }
      >
        {t("shopifyProductSalesReport.download")}
      </Button>
    </ReportHeader>
  );
}
